function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "calculate-values");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72,103.81v7.94H63.2v-7c-4.38-.26-9-1.55-11.64-3.31l-1.23-.83,2.73-9.06,2.22,1.36a19.68,19.68,0,0,0,9.93,2.8c5,0,7.92-2.27,7.92-6.09,0-3-1.22-5.08-7.65-7.56-9.29-3.29-13.82-8.31-13.82-15.32,0-6.84,4.47-12.24,11.54-14.15V44.25H72V52a21.43,21.43,0,0,1,8.48,2.44l1.44.82-3,8.84-2.1-1.15a16.7,16.7,0,0,0-8-2c-5.12,0-6.93,2.75-6.93,5.1,0,2.8,1.22,4.6,8.15,7.29,6.62,2.55,13.4,6.43,13.4,15.81C83.42,96.18,79.1,101.68,72,103.81Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.42,77.66A58.7,58.7,0,0,1,49.77,21.5V35.9L74.3,18,49.77,0V12.74a67.23,67.23,0,0,0-.23,129.79l2.21-8.13A58.9,58.9,0,0,1,8.42,77.66Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.2,13.48,82,21.61A58.81,58.81,0,0,1,84,134.5V120.1l-24.53,18L84,156V143.27A67.23,67.23,0,0,0,84.2,13.48Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 133.74,
    height: 156,
    viewBox: "0 0 133.74 156"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/calculate-values-icon.f175ac25.svg";
export { SvgComponent as ReactComponent };